import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../axios/axiosUmbraco";
import { useTranslate } from "./TranslationText";
import SectionTitle from "./SectionTitle";
import { getFileName } from "../helper/getFileName";

const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

/**
 * A unified component to display sponsors or partners fetched from Umbraco.
 * Uses the preferred UI styling from SponsorAndPartner.js.
 * 
 * @param {string} fetchId - The Umbraco content ID to fetch data from.
 * @param {string} sectionId - The ID for the section anchor.
 * @param {string} translationKey - The translation key for the section title.
 * @param {string} defaultTitle - The default title if translation is missing.
 */
export default function UnifiedSponsorsSection({ fetchId, sectionId, translationKey, defaultTitle }) {
  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const [sponsors, setSponsors] = useState([]);
  const [total, setTotal] = useState(0);
  const { translate } = useTranslate();

  function getCurrentLanguageUmbraco() {
    const lang = localStorage.getItem("eahsLang") ?? "en";
    return lang === "en" ? 'en-US' : 'ar-AE';
  }

  useEffect(() => {
    async function getdata() {
      if (!fetchId) return;
      try {
        const response = await axios.get(`/umbraco/delivery/api/v1/content?fetch=${fetchId}&skip=0&take=20`, {
          headers: {
            "accept-language": getCurrentLanguageUmbraco(),
          }
        });
        
        const formattedData = response.data?.items.map((item) => ({
          name: item.properties?.title || "",
          image: item.properties?.image ? item.properties?.image[0]?.url : '',
          link: item?.properties?.link || '',
          sort: item.properties?.sort ? item.properties?.sort : 0,
        }));

        setTotal(response.data?.total || 0);
        setSponsors(formattedData.sort((a, b) => a.sort - b.sort));
      } catch (error) {
        console.error("Error fetching unified sponsors data:", error);
        setTotal(0);
      }
    }
    getdata();
  }, [currentLanguage, fetchId]);

  if (total === 0 || sponsors.length === 0) {
    return null;
  }

  return (
    <>
      <SectionTitle
        isContainer={true}
        section_id={sectionId}
        section_name={translate(translationKey, defaultTitle)}
      />

      <div className="container mobile-extra-padding">
        <div className="row justify-content-center">
          {sponsors.map((item, index) => (
            <div
              key={index}
              className="col-lg-3 col-md-4 col-sm-6 col-6 text-center"
            >
              {item.link ? (
                <a href={item.link} target="_blank" rel="noreferrer">
                  <img
                    src={`${MediaBaseURL}${item.image}`}
                    alt={item.name}
                    className="border-15"
                    style={{
                      height: "350px",
                      width: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />
                </a>
              ) : (
                <img
                  src={`${MediaBaseURL}${item.image}`}
                  alt={item.name}
                  className="border-15"
                  style={{
                    height: "350px",
                    width: "100%",
                    maxWidth: "100%",
                    objectFit: "contain",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
